/* TimestampComponent.js */

"use strict";

const DefaultColumnComponent = require("@gluenetworks/steve_ui_widgets").GridGl.DefaultColumnComponent;
const Renderer = require("./TimestampRenderer");
const _ = require("lodash");

class TimestampColumnComponent extends DefaultColumnComponent {
    constructor(value) {
        super(value);

        //this._timestamp = _.get(configOptions, "value", "");
        this._timestamp = value;
        this._renderer = new Renderer(this);
        this._registerListeners();
    }
    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS */
    /*******************************************/
    _registerListeners() {}

    _unregisterListeners() {}
    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS */
    /* START PUBLIC COMPONENT MODEL METHODS */
    /*******************************************/
    get renderer() {
        return this.getRenderer();
    }
    getRenderer() {
        return this._renderer;
    }
    shutdown() {
        this._unregisterListeners();
        let prom = this._renderer._shutdown();
        this._renderer = undefined;
        this._timestamp = undefined;
        return prom;
    }
    /*******************************************/
    /* END COMPONENT MODEL METHODS */
    /* START HANDLER METHODS */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE METHODS */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS */
    /* START PUBLIC API METHODS */
    /*******************************************/

    setTimestamp(newVal) {
        this._timestamp = newVal;
        this.emit("Timestamp", newVal);
        return this;
    }

    setValue(newVal) {
        if (!_.isUndefined(newVal)) {
            this.setDate(newVal);
        }
    }

    setDate(newVal) {
        this._value = newVal;
        this.emit("Date", newVal);
        return this;
    }

    getTimestamp() {
        return this._timestamp;
    }

    static SortFunction(a, b) {
        let aVal = a[1],
            bVal = b[1];
        if (aVal > bVal) {
            return 1;
        }
        if (aVal < bVal) {
            return -1;
        }
        return 0;
    }

    /*******************************************/
    /* END PUBLIC API METHODS */
    /*******************************************/
}
module.exports = TimestampColumnComponent;
